import { render, staticRenderFns } from "./analysisDetection.vue?vue&type=template&id=4bf006cb&scoped=true&"
import script from "./analysisDetection.vue?vue&type=script&lang=js&"
export * from "./analysisDetection.vue?vue&type=script&lang=js&"
import style0 from "./analysisDetection.vue?vue&type=style&index=0&id=4bf006cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf006cb",
  null
  
)

export default component.exports